import React, { useState, useCallback, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(() => ({
  dialogActions: {
    justifyContent: "center"
  },
  formControl: {
    width: "50%"
  },
  menuPaper: {
    maxHeight: 200
  },
  gridContainer: {
    minHeight: 150
  },
  fullWidth: {
    width: "100%"
  },
  chapterName: {
    fontSize: 24
  }
}));

const MemberCountDialog = ({
  open,
  editing,
  chapterName,
  year,
  originalCount,
  chapterList,
  onClose,
  onSave
}) => {
  const classes = useStyles();
  const [fiscalYear, setFiscalYear] = useState(year || -1);
  const [count, setCount] = useState(originalCount);
  const [isDirty, setDirty] = useState(false);

  useEffect(() => {
    if (open) {
      setDirty(false);
      setFiscalYear(year);
      setCount(originalCount);
    }
  }, [open, year, originalCount]);

  const handleSave = useCallback(() => {
    setDirty(true);
    if (!count || count < 0 || !fiscalYear || fiscalYear < 0) {
      return;
    }
    onSave(fiscalYear, count);
  }, [count, fiscalYear]);

  const handleCountChange = useCallback(({ target: { value } }) => {
    const digitsOnly = new RegExp(/^\d+$/);

    if (digitsOnly.test(value) || value.length === 0) {
      setCount(value);
    }
  }, []);

  const handleFiscalYear = useCallback(({ target: { value } }) => {
    setFiscalYear(value);
  }, []);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography
          className={classes.chapterName}
        >{`Member Count for ${chapterName}`}</Typography>
        <Typography>
          Please submit numbers as of September 30th of the Fiscal Year chosen
          from the dropdown
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.gridContainer}
          spacing={2}
        >
          <Grid item className={classes.formControl}>
            <FormControl variant="outlined" className={classes.fullWidth}>
              <InputLabel id="demo-simple-select-outlined-label">
                Fiscal Year
              </InputLabel>
              <Select
                disabled={editing}
                error={isDirty && (!fiscalYear || fiscalYear < 0)}
                labelId="demo-simple-select-outlined-label"
                value={fiscalYear}
                onChange={handleFiscalYear}
                label="Fiscal Year"
                MenuProps={{ classes: { paper: classes.menuPaper } }}
              >
                <MenuItem value={-1}>
                  <em>None</em>
                </MenuItem>
                {chapterList.map(value => (
                  <MenuItem value={value} key={`fiy-${value}`}>
                    FY{value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item className={classes.formControl}>
            <TextField
              error={isDirty && !count}
              className={classes.fullWidth}
              variant="outlined"
              value={count}
              label="Count"
              onChange={handleCountChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button color="success" variant="contained" onClick={handleSave}>
          Save
        </Button>
        <Button color="danger" variant="contained" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberCountDialog;
